
import './Calendar.css';
import {Navigate} from "react-big-calendar";
import {getWeekRange} from "./WeexCalendar";
import {useContext, useEffect, useState} from "react";
import {APIContext, defineBackend} from "../Globals.tsx";


export default function WeexCalendarGrid({date, localizer, setCurrentDate, setToolbar,...props}){
  const range = WeexCalendarGrid.range(date, { localizer });
  const [courses, setCourses] = useState([]);
  const [backend, setBackend] = useState(null);
  const {fetchCalendarWeek} = useContext(APIContext);

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const backendParam = queryParams.get('weex');
    const date = queryParams.get('date');

    let backend_ = defineBackend(backendParam);
    setBackend(backend_);
    if(date){
      setToolbar(false);
      setCurrentDate(new Date(date));
    }
  }, []);

  useEffect(() => {
    const {start, end} = getWeekRange(date);
    if(backend){
      fetchCourses(start, end).then(setCourses);
    }
  }, [date, backend]);

  async function fetchCourses(startDate, endDate){
    return await fetchCalendarWeek(backend, startDate, endDate).then((ans) => {
      return ans?.days?.flat()?.map((item) => {
        const start = new Date(`${item.startDate}T${item.startTime}:00`);
        const end = new Date(`${item.endDate}T${item.endTime}:00`);
        return {
          id: item.id,
          title: item.type,
          start: start,
          end: end,
          resource: item,
        }
      });
    });
  }
  const sameDay = (a, b) =>
    a.getFullYear() === b.getFullYear() &&
    a.getMonth() === b.getMonth() &&
    a.getDate() === b.getDate();

  // Only hours that actually have a course somewhere in the week become a row,
  // sorted ascending. Every day column shares these rows, so all courses that
  // start in the same hour align at the same height.
  const hours = [...new Set((courses ?? []).map((c) => c.start.getHours()))]
    .sort((a, b) => a - b);

  const renderCard = (c) => {
    const r = c.resource;
    const {background, color} = courseColors(c.title);
    console.log(c.title, r);
    return (
      <div
        className="weex-course-card"
        key={c.id}
        onClick={() => props.onSelectEvent?.(c)}
        style={{background, color}}
      >
        <strong>{c.title}</strong>
        <div className="weex-course-time">{r.startTime} - {r.endTime}</div>
        <div className="weex-course-time">{r.coach.split(" ")[0]}</div>
      </div>
    );
  };

  return (
    <div className="weex-grid">
      {/* weekday header row */}
      {range.map((day) => (
        <div className="weex-grid-head" key={day.toISOString()}>
          <span className="weekday-full">{weekday[day.getDay()]}</span>
          <span className="weekday-short">{weekdayShort[day.getDay()]}</span>
        </div>
      ))}

      {/* one row per present start-hour; each cell holds that day's courses for that hour */}
      {hours.map((hour) =>
        range.map((day) => {
          const cell = (courses ?? [])
            .filter((c) => sameDay(c.start, day) && c.start.getHours() === hour)
            .sort((a, b) => a.start - b.start);
          return (
            <div className="weex-grid-cell" key={day.toISOString() + '-' + hour}>
              {cell.map(renderCard)}
            </div>
          );
        })
      )}
    </div>
  );
}

const weekday = ['SONNTAG', 'MONTAG', 'DIENSTAG', 'MITTWOCH', 'DONNERSTAG', 'FREITAG', 'SAMSTAG'];
const weekdayShort = ['SO', 'MO', 'DI', 'MI', 'DO', 'FR', 'SA'];

// Card colours per course type. Order matters: "Kettlebell Strength" must match
// kettlebell before strength. Default text colour is #0D0E0F, except the dark
// backgrounds (kettlebell / default #095295) which use light text.
function courseColors(type){
  const t = (type || '').toLowerCase();
  if(t.includes('kettlebell')) return {background: '#095295', color: '#E0E6EE'};
  if(t.includes('core'))       return {background: '#0382D1', color: '#0D0E0F'};
  if(t.includes('strength'))   return {background: '#AABAC6', color: '#0D0E0F'};
  if(t.includes('team'))       return {background: '#718493', color: '#0D0E0F'};
  return {background: '#095295', color: '#E0E6EE'};
}

WeexCalendarGrid.navigate = (date, action, {localizer}) => {
  switch(action){
    case Navigate.PREVIOUS:
      return localizer.add(date, -7, 'day');

    case Navigate.NEXT:
      return localizer.add(date, 7, 'day');

    default:
      return date;
  }
};

WeexCalendarGrid.title = (date, {localizer}) => {
  return ""//`${localizer.startOf(date, 'week').toLocaleDateString('de-DE')} - ${localizer.endOf(date, 'week').toLocaleDateString('de-DE')} KW ${getISOWeek(date)}`;
};

WeexCalendarGrid.range = (date, { localizer }) => {
  const start = localizer.startOf(date, 'week');
  const end = localizer.endOf(date, 'week');

  let current = new Date(start);
  const range = [];

  while (localizer.lte(current, end, 'day')) {
    range.push(new Date(current));
    current = localizer.add(current, 1, 'day');
  }

  return range;
};